module.exports = __webpack_public_path__ + "fk.svg?5e30840a77641f770587626bcff0639d";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/fk.svg
// module id = 1054
// module chunks = 27